<template>
  <div class="chart-years">
    <div class="bars">
      <div
        :class="['bar-group', { selected: year.key == getPaint.to }]"
        v-for="(year, yearIndex) in years"
        :key="year.key"
        :style="{ width: 100 / years.length + '%' }"
      >
        <div
          class="bar"
          :style="{ height: (year.value * barMaxHeight) / maxValue + 'px' }"
        >
          <div class="bar-value">{{ year.value }}</div>
        </div>
        <div class="foot"></div>
        <div
          :class="[
            'x-axis',
            {
              last: yearIndex === years.length - 1,
              current: year.key == getPaint.to,
              visible:
                (yearIndex === 0 &&
                  $tvaMq !== 'mobile' &&
                  $tvaMq !== 'tablet') ||
                (yearIndex === years.length - 1 &&
                  $tvaMq !== 'mobile' &&
                  $tvaMq !== 'tablet') ||
                year.key == getPaint.to
            }
          ]"
        >
          {{ year.key }}
        </div>
        <div
          :class="[
            'period',
            {
              visible:
                year.showPeriod && $tvaMq !== 'mobile' && $tvaMq !== 'tablet',
              first: yearIndex == 0
            }
          ]"
        >
          {{ year.period }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
export default {
  name: "chart-years",
  props: {
    height: { default: 101 }
  },
  computed: {
    years() {
      let groups = _.groupBy(this.$ml.get("data"), d => d.to);
      let res = [];
      let previousPeriod = "";
      _.forEach(groups, (year, yearKey) => {
        res.push({
          key: yearKey,
          value: +year.length,
          period: year[0].period,
          showPeriod: year[0].period !== previousPeriod
        });
        previousPeriod = year[0].period;
      });
      return res;
    },
    maxValue() {
      return _.maxBy(this.years, d => d.value).value;
    },
    barMaxHeight() {
      return this.height * 0.58;
    },
    ...mapGetters(["getPaint"])
  }
};
</script>

<style lang="scss" scoped>
.chart-years {
  width: 100%;
  padding-top: 25px;
  .bars {
    display: flex;
    .bar-group {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      .bar {
        background: rgba(255, 255, 255, 0.15);
        border-top: solid 0px rgba(255, 255, 255, 0.15);
        height: 10px;
        width: 100%;
        flex-shrink: 0;
        position: relative;
        .bar-value {
          display: none;
          position: absolute;
          top: -20px;
          width: 20px;
          text-align: center;
          left: calc(50% - 10px);
          @include number-primary-center;
        }
      }
      .foot {
        width: calc(100% - 4px);
        height: 1px;
        opacity: 0.5;
        margin: 5px 2px 1px;
        background: #979797;
        flex-shrink: 0;
      }
      .x-axis {
        @include number-secondary_dark-left;
        height: 16px;
        opacity: 0;
        margin-top: 2px;
        &.visible {
          opacity: 1;
        }
        &.last {
          text-align: right;
        }
        &.current {
          @include number-white-center;
        }
      }
      .period {
        opacity: 0;
        height: 16px;
        white-space: nowrap;
        @include subtitle-UI_gray_3-left-desktop;
        padding-left: 4px;
        margin-left: 50%;
        position: relative;

        &::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: 2px;
          height: 180%;
          width: 1px;
          opacity: 0.7;
          background: $ui-gray-3;
        }
        &.first {
          margin-left: 0;
          &::after {
            height: 80%;
          }
        }
        &.visible {
          opacity: 1;
        }
      }
      &.selected {
        .bar {
          background: rgba($primary, 0.6);
          border-top: solid 2px $primary;
          .bar-value {
            display: block;
          }
        }
        .foot {
          background: $white;
          opacity: 1;
          height: 2px;
          margin-top: 4.5px;
          margin-bottom: 0.5px;
        }
      }
    }
  }
}
</style>
